import Http from 'axios'
import {API_URL, VERSION} from '../../../config/config'

function initialState() {
    return {
        model: null,
        loading: false,
        modelData: [],
    }
}

const getters = {
    loading: state => state.loading,
    model: state => state.model,
    modelData: state => state.modelData
}

const actions = {
    changePassword({
                       commit,
                       state,

                   }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/change-password')
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },

};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setModel(state, model) {
        console.log("Model is " + model);
        state.model = model
    },
    setModelData(state, data) {
        console.log("Daaaaaa  " + JSON.stringify(data));
        state.modelData = data;
        console.log("state data " + JSON.stringify(state.modelData));
    },

}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}